import { useCallback, useEffect, useRef } from "react";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { makePostCallForOncologySubmission } from "../apis/makePostCallForOncologySubmission";
import { OncologySubmissionFilterPayload } from "./useFilterPayload";
import { OncologySubmissionTableState } from "./useOncologySubmissionTableData";

export const useFilterAndSearchEffect = (
  filterPayload: OncologySubmissionFilterPayload | null,
  initialDataFetchingExecuted: boolean,
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>,
  setOncologySubmissionState: React.Dispatch<
    React.SetStateAction<OncologySubmissionTableState>
  >,
  setPaginationResetCount: React.Dispatch<React.SetStateAction<number>>,
): void => {
  const initialDataFetchingExecutedRef = useRef(initialDataFetchingExecuted);
  const setTableDataRef = useRef(setTableData);
  const setOncologySubmissionStateRef = useRef(setOncologySubmissionState);
  const setPaginationResetCountRef = useRef(setPaginationResetCount);

  useEffect(() => {
    initialDataFetchingExecutedRef.current = initialDataFetchingExecuted;
    setTableDataRef.current = setTableData;
    setOncologySubmissionStateRef.current = setOncologySubmissionState;
    setPaginationResetCountRef.current = setPaginationResetCount;
  }, [
    initialDataFetchingExecuted,
    setTableData,
    setOncologySubmissionState,
    setPaginationResetCount,
  ]);

  const fetchData = useCallback(() => {
    if (filterPayload) {
      makePostCallForOncologySubmission(
        filterPayload,
        setOncologySubmissionStateRef.current,
        setTableDataRef.current,
        setPaginationResetCountRef.current,
      );
    }
  }, [filterPayload]);

  useEffect(() => {
    if (filterPayload && initialDataFetchingExecutedRef.current) {
      fetchData();
    }
  }, [filterPayload, fetchData]);
};
